export function tab(tabButtonEl, tabListEl, tabContentsEl, tabWrap) {
  if ($(tabWrap).length) {
    $(tabWrap).each(function() {
      let parent = $(this);
      parent.find(tabButtonEl).click(function () {
        let index = parent.find(tabListEl + ' ' + tabButtonEl).index(this);
        parent.find(tabContentsEl).removeClass("is-active");
        parent.find(tabContentsEl).eq(index).addClass("is-active");
        parent.find(tabListEl + ' ' + tabButtonEl).removeClass("is-active");
        $(this).addClass("is-active");
      });
    });
  }
}

